import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export interface RmComponentsCredentialsDTO extends z.infer<typeof RmComponentsCredentialsDTORuntype> {}
export const RmComponentsCredentialsDTORuntype = z.object({
    client_id: z.string(),
    client_secret: z.string(),
});

export interface RmComponentsCredentialsInputDTO extends z.infer<typeof RmComponentsCredentialsInputDTORuntype> {}
export const RmComponentsCredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    client_secret: z.string().optional(),
});

export interface RmComponentsResponseBodyDTO extends z.infer<typeof RmComponentsResponseBodyDTORuntype> {}
export const RmComponentsResponseBodyDTORuntype = z.object({
    data: RmComponentsCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
